import makeUrl from "../../utils/make-url";
import config from "../config";

const routes = config.info;
const root = `/${routes.root}`;

export const index = (...args) => makeUrl(root, ...args);
export const about = (...args) => makeUrl(`${root}/${routes.about}`, ...args);
export const conditions = (...args) =>
  makeUrl(`${root}/${routes.conditions}`, ...args);
export const kycaml = (...args) => makeUrl(`${root}/${routes.kycaml}`, ...args);
export const privacy = (...args) =>
  makeUrl(`${root}/${routes.privacy}`, ...args);
export const responsiblegame = (...args) =>
  makeUrl(`${root}/${routes.responsiblegame}`, ...args);
export const cookies = (...args) =>
  makeUrl(`${root}/${routes.cookies}`, ...args);
export const support = (...args) =>
  makeUrl(`${root}/${routes.support}`, ...args);
export const welcomeBonus = (...args) =>
  makeUrl(`${root}/${routes.welcomeBonus}`, ...args);
export const loyaltyProgram = (...args) =>
  makeUrl(`${root}/${routes.loyaltyProgram}`, ...args);

export default {
  index,
  about,
  conditions,
  kycaml,
  privacy,
  responsiblegame,
  cookies,
  support,
  welcomeBonus,
  loyaltyProgram,
};
